import React from "react";
import { render } from "react-dom";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import FinComunicacion from "./views/FinComunicacion";
import SolicitarMiTarjeta from "./views/SolicitarMiTarjeta";
import "assets/css/material-react.css?v=1.10.0";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
library.add(fas, far);

const App = () => {
  return (
    <Routes>
      <Route exact path="/" element={<SolicitarMiTarjeta />} />
      <Route path="/gracias" element={<FinComunicacion />} />
    </Routes>
  );
};

render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);
